module.exports = __webpack_public_path__ + "img/logo.e738107.png";